import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 6943,
  clicks: 99,
  adsSpendDollars: 344,
  budgetDollars: 14500,
  salesDollars: 4213,
  bestEstimateRoas: 12.25,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.02,
  newCustomersAcquired: 5,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
